import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedSourceDataAtom } from '../../../atoms/selectedSourceData';
import { getSourceOptions } from '../sourceOptions';

export function SelectSourceType({ size }) {
  const intl = useIntl();
  const [sourceData, setSourceData] = useAtom(selectedSourceDataAtom);

  const handleSourceTypeChange = (option) => {
    setSourceData({
      ...sourceData,
      sourceName: undefined,
      sourceType: option.sourceType,
    });
  };

  return (
    <Dropdown
      id="display-provide-source"
      label={intl.formatMessage({
        defaultMessage: 'Video Source',
        id: '55951',
      })}
      labelPosition="top"
      onChange={(selectedOption) =>
        handleSourceTypeChange(selectedOption.value)
      }
      options={getSourceOptions(intl)}
      placeholder={intl.formatMessage({
        defaultMessage: 'Select Video Source',
        id: '5704e',
      })}
      size={size}
      value={getSourceOptions(intl).find(
        (option) => option.value.sourceType === sourceData?.sourceType,
      )}
      variant="secondary"
    />
  );
}

SelectSourceType.propTypes = { size: PropTypes.string };
SelectSourceType.defaultProps = { size: undefined };

export default { SelectSourceType };
